exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-confirm-send-modal_container{width:600px}.c-confirm-send-modal_container p{padding:0 35px;margin-bottom:30px;color:#112363}.c-confirm-send-modal_buttons-container{padding:20px 35px;height:79px;border-top:1px solid rgb(90.6666666667%,91.3725490196%,93.8823529412%)}.c-confirm-send-modal_buttons-container .a-button-secondary{margin-right:12px}.c-confirm-send-modal .c-modal-content_children{padding:0}.c-confirm-send-modal .c-modal-close{display:none}", ""]);

// exports
